export default __webpack_public_path__ + "static/media/envirobox.e1d696dd.webp";